export default __webpack_public_path__ + "static/media/add.1441884b.svg";